// extracted by mini-css-extract-plugin
export default {"container":"NcLoader_container__QlfiC","loader":"NcLoader_loader__JstFW"};